import axios from 'axios';
import { ISeccionBlog } from '@/shared/model/seccion-blog.model';

const baseApiUrl = 'api/seccion-blogs';

export default class SeccionBlogService {
  public findByNota(notaId: number): Promise<ISeccionBlog[]> {
    return new Promise<ISeccionBlog[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/por-nota/${notaId}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public find(id: number): Promise<ISeccionBlog> {
    return new Promise<ISeccionBlog>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public create(entity: ISeccionBlog): Promise<ISeccionBlog> {
    return new Promise<ISeccionBlog>((resolve, reject) => {
      axios
        .post(baseApiUrl, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public update(entity: ISeccionBlog): Promise<ISeccionBlog> {
    return new Promise<ISeccionBlog>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public deleteByNota(notaId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/por-nota/${notaId}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
